import React from "react";
import { money } from "./boleteraHelper";

const Carrito = ({ lineas, onAdd }) => {
  if (!lineas.length) {
    return (
      <div className="text-center text-muted py-3" style={{ fontSize: "12.5px" }}>
        Elige un destino y toca una tarifa para agregar boletos.
      </div>
    );
  }

  return (
    <div>
      {lineas.map((l) => (
        <div key={l.tipo.id} className="boletera-linea">
          <div style={{ flex: 1, minWidth: 0 }}>
            <div className="text-truncate" style={{ fontWeight: 600, fontSize: "13.5px" }}>
              {l.tipo.nombre}
            </div>
            <div style={{ fontSize: "11.5px", color: "#777a89" }}>{money(l.precio)} c/u</div>
          </div>
          <div className="boletera-stepper">
            <button type="button" onClick={() => onAdd(l.tipo.id, -1)} aria-label="Quitar uno">
              <i className="mdi mdi-minus"></i>
            </button>
            <span>{l.cantidad}</span>
            <button type="button" onClick={() => onAdd(l.tipo.id, 1)} aria-label="Agregar uno">
              <i className="mdi mdi-plus"></i>
            </button>
          </div>
          <div style={{ width: 80, textAlign: "right", fontWeight: 600 }}>{money(l.subtotal)}</div>
        </div>
      ))}
    </div>
  );
};

export default Carrito;
